// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_PH4","cls2":"LoswpExitIntentModal-cls2_SKs LoswpExitIntentModal-cls1_PH4"};